export default __webpack_public_path__ + "static/media/side.7cd3edf6.png";